import { prepareSort } from 'helpers/participantsTableSort'
import { UsersFilterOptions } from 'enum/users-filter-options.enum'
import { applyFilters } from '../../../helpers/filterData.helper'
import api from '../..'
import { UserData } from './types'

export interface UsersSearchParams {
  page: number
  area?: number[]
  searchText
  sort: any
  usersFilter: any
  perPage: number
  fastFilters?: number
}

const listActiveParticipants = ({
  page,
  area = [],
  searchText = '',
  sort,
  usersFilter,
  perPage,
  fastFilters,
}: UsersSearchParams) => {
  const q = { s: '', g: [{}] } as any

  q['s'] = prepareSort(sort)
  q['m'] = 'and'
  q['lms_active_true'] = true
  q[
    'full_name_or_identifier_or_position_or_lms_profiles_name_or_area_name_or_email_cont'
  ] = searchText
  if (area[0] !== 0) q['area_id_in'] = area
  if (fastFilters) {
    const { withProfiles, noProfiles, admins } = UsersFilterOptions
    switch (fastFilters) {
      case withProfiles:
        q['lms_profiles_id_null'] = false
        break
      case noProfiles:
        q['lms_profiles_id_null'] = true
        break
      case admins:
        q['abac_default_admin_true'] = true
        break
    }
  }

  q['g'] = applyFilters(usersFilter)

  return api
    .post<{ data: UserData[] }>(`administration/users/search`, {
      page,
      perPage,
      q,
    })
    .then(({ data, headers }) => ({
      data: data.data.map(({ attributes }) => attributes),
      total: parseInt(headers['total']),
      perPage: parseInt(headers['per-page']),
    }))
}

export default listActiveParticipants
